import { NgModule } from '@angular/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';

@NgModule({
    imports: [
        MatDialogModule,
        MatExpansionModule,
        MatToolbarModule,
        MatIconModule,
        MatButtonModule,
        MatListModule,
        MatInputModule,
        MatFormFieldModule,
        MatRadioModule,
        MatTabsModule,
        MatDatepickerModule,
        MatMomentDateModule,
        MatSelectModule,
        MatChipsModule,
        MatSlideToggleModule,
        MatDividerModule,
        MatBadgeModule,
        MatCheckboxModule,
        MatCardModule,
        MatRippleModule,
        MatAutocompleteModule
    ],
    providers: [

    ],
    exports: [
        MatDialogModule,
        MatToolbarModule,
        MatButtonModule,
        MatIconModule,
        MatListModule,
        MatInputModule,
        MatFormFieldModule,
        MatRadioModule,
        MatTabsModule,
        MatDividerModule,
        MatDatepickerModule,
        MatSelectModule,
        MatChipsModule,
        MatBadgeModule,
        MatExpansionModule,
        MatCheckboxModule,
        MatSlideToggleModule,
        MatCardModule,
        MatRippleModule,
        MatAutocompleteModule
    ],
})
export class MaterialModule { }
